import { render, staticRenderFns } from "./manage_college_manpower.vue?vue&type=template&id=15299829&scoped=true&"
import script from "./manage_college_manpower.vue?vue&type=script&lang=js&"
export * from "./manage_college_manpower.vue?vue&type=script&lang=js&"
import style0 from "./manage_college_manpower.vue?vue&type=style&index=0&id=15299829&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15299829",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VContainer,VDataTable,VIcon,VTextField})
